<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn
          v-if="permissions.status_rest_home.write"
          class="v-primary mb-1"
          v-on:click="handleModalCreate"
        >
          <span class="fa fa-plus"></span> Novo
        </v-btn>
        <!-- Modal create -->
        <b-modal id="createStatus" hide-footer>
          <template v-slot:modal-title>Novo status</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <LabelRequiredField label="Nome" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal create -->
        <v-card>
          <v-card-title>
            Status cliente
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="statusRestHomes"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.edit`]="{ item }">
              <!-- Modal alterar status -->
              <b-modal :id="String(item.id)" hide-footer>
                <template v-slot:modal-title>Editar status</template>
                <div class="d-block">
                  <div class="container">
                    <b-overlay
                      :show="loadingStatusRestHomeUpdate"
                      opacity="0.99"
                    >
                      <form v-on:submit="update" method="post">
                        <div class="row">
                          <WarningRequiredFields />
                          <ErrorsMessages :errors="errors" />
                          <div class="col-md-12">
                            <LabelRequiredField label="Nome" />
                            <input
                              :disabled="!permissions.status_rest_home.edit"
                              type="text"
                              v-model="name"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-12">
                            <h6>
                              <span class="text-muted">Criação:</span>
                              {{ formatDate(item.created_at) }}
                            </h6>
                            <h6>
                              <span class="text-muted">Última alteração:</span>
                              {{ formatDate(item.updated_at) }}
                            </h6>
                          </div>
                          <div class="col-md-12 text-right">
                            <v-btn
                              class="v-primary m-1"
                              @click="$bvModal.hide(String(item.id))"
                            >
                              <span class="fa fa-arrow-left"></span> Voltar
                            </v-btn>
                            <v-btn
                              v-if="permissions.status_rest_home.edit"
                              :disabled="loadingUpdate"
                              type="submit"
                              class="v-success m-1"
                            >
                              <span class="fa fa-check"></span>
                              {{ loadingUpdate ? "Carregando" : "Salvar" }}
                            </v-btn>
                            <v-btn
                              v-if="permissions.status_rest_home.remove"
                              class="v-danger m-1"
                              v-confirm="{
                                html: true,
                                loader: false,
                                ok: (dialog) => deleteStatus(dialog, item),
                                cancel: () => {},
                                message:
                                  'Deseja realmente apagar o status? <hr /> Só pode apagar caso não exista vinculo do status com cliente!',
                                okText: 'Confirmar',
                                cancelText: 'Cancelar',
                              }"
                            >
                              <span class="fa fa-times-circle"></span> Apagar
                            </v-btn>
                          </div>
                        </div>
                      </form>
                    </b-overlay>
                  </div>
                </div>
              </b-modal>
              <!-- /Modal alterar status -->
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import api from "../services/api";
import toast from "../components/ToastNotification";
import { formatDate } from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "StatusRestHome",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Nome", value: "name" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      statusRestHome: {},
      statusRestHomes: [],
      id: "",
      name: "",
      loadingCreate: false,
      loadingUpdate: false,
      loadingStatusRestHomeUpdate: false,
      loading: true,
    };
  },
  async created() {
    this.permissions = adminData().permissions;

    this.getStatusRestHomes();
  },
  methods: {
    formatDate,
    handleClickRowTable(item) {
      this.errors = [];
      this.handleModalStatus(item.id);
      this.$bvModal.show(String(item.id));
    },
    async getStatusRestHomes(page = 1) {
      try {
        this.loading = true;

        const response = await api.get("/admin/rest-home/status/paginate", {
          params: { page },
        });

        const { status } = response.data;

        this.statusRestHomes = status;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const { name } = this;

        let params = {
          name,
        };

        const response = await api.post(
          "/admin/rest-home/status/create",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("createStatus");
          this.getStatusRestHomes();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { id, name } = this;

        let params = {
          id,
          name,
        };

        const response = await api.put("/admin/rest-home/status/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(String(id));
          this.getStatusRestHomes();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.name = "";
      this.$bvModal.show("createStatus");
    },
    async handleModalStatus(id) {
      try {
        this.loadingStatusRestHomeUpdate = true;

        this.id = id;

        const response = await api.get("/admin/rest-home/status/get", {
          params: { id },
        });

        const { status } = response.data;

        this.statusRestHome = status;
        this.id = status.id;
        this.name = status.name;
        this.loadingStatusRestHomeUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteStatus(dialog, status) {
      try {
        const { id } = status;

        let data = { id };

        const response = await api.delete("/admin/rest-home/status/delete", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.getStatusRestHomes();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>